<eva-chatbot
  #evaChatbot
  [attr.mode]="mode"
  [attr.position]="position"
  [attr.size]="size"
  [attr.user-name]="userName"
  [attr.user-email]="userEmail"
  auto-initialize
  (eva-close)="onClose()"
  (eva-quick-action)="onQuickAction($event)"
  (eva-widget-action)="onWidgetAction($event)"
></eva-chatbot>
